var scrolling = require('scrolling');

var $nav = document.querySelector('.fjs-nav-scroll'),
	$body = document.body,
    $html = document.documentElement,
    winHeight = window.innerHeight,
    docHeight = Math.max( $body.scrollHeight, $body.offsetHeight, $html.clientHeight, $html.scrollHeight, $html.offsetHeight ) - winHeight,
    percentage = 0,
    navHeight = $nav.scrollHeight,
    $articles = document.querySelectorAll('.fjs-articles'),
   	stickyTopPos = $nav.offsetTop;

function scroll(e) {
	var scrollY = this.pageYOffset,
		scrollClass = 'js-has-scrolled';

	if(scrollY > $html.clientHeight / 1.2) {
		$body.classList.add(scrollClass);
	} else {
		$body.classList.remove(scrollClass);
	}

	for(var i = 0; i < $articles.length; i++) {
		var $article = $articles[i],
			visible = isElementInViewport($article),
			active = isActive($article);
			month = '';

		if(visible) {
			if ($article.classList) {
				$article.classList.add('visible');
			}
			else {
				var regExp = new RegExp('(\\s|^)visible(\\s|$)');
				if (!$article.className.match(regExp)) {
					$article.className += ' visible';
				}
			}
		}

		toggleActive($article, active);
	}
}

function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();

    return (
		rect.top <= winHeight
	);
}

function isActive (el) {
    var rect = el.getBoundingClientRect();

    return (
		rect.top <= winHeight / 2 && rect.bottom >= winHeight / 2
    );
}

function toggleActive($article, state) {
	var $targetArticle = document.querySelector('a[href="#' + $article.id + '"]');

	if(state) {

		if ($targetArticle.classList) {
			$targetArticle.classList.add('js-is-active');
		}
		else {
			var regExp = new RegExp('(\\s|^)visible(\\s|$)');
			if (!$targetArticle.className.match(regExp)) {
				$targetArticle.className += ' js-is-active';
			}
		}

		var $activeArticle = document.querySelector('#article-' + $article.id);
		var $activeMonth = document.querySelector('#' + $article.dataset.month);

		if(!$activeMonth.checked) {
			$activeMonth.click();
		}

		if(!$activeArticle.checked) {
			var duration = 0;
				duration = 500;

			setTimeout(function(){
				$activeArticle.click();			
			}, duration);
		}

	} else {
		if ($targetArticle.classList) {
			$targetArticle.classList.remove('js-is-active');
		}
		else {
			if (!$targetArticle.className.match('visible')) {
				removeClass($targetArticle, "visible");
			}
		}
	}
}

function removeClass(ele,cls) {
   var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
   ele.className = ele.className.replace(reg,' ');
}

if($nav) {
	scrolling(window, scroll);

	$nav.onmouseover = function() {
		var nameOfClass = 'js-no-scroll';
		
		if ($body.classList) {
			$body.classList.add(nameOfClass);
		}
		else {
			var regExp = new RegExp('(\\s|^)' + nameOfClass + '(\\s|$)');
			if (!$body.className.match(regExp)) {
				$body.className += ' ' + nameOfClass;
			}
		}
	}

	$nav.onmouseout = function () {
		var nameOfClass = 'js-no-scroll';

		if ($body.classList) {
			$body.classList.remove(nameOfClass);
		}
		else {
			var regExp = new RegExp('(\\s|^)' + nameOfClass + '(\\s|$)');
			if ($body.className.match(regExp)) {
				$body.className.replace(regExp, ' ');
			}
		}
	}
}
